import React, { useState } from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { ApiService } from '../../Components/Services/apiservices';
let apiServices = new ApiService();

function Contact() {
    // Initial state object for easy resetting
    const initialFormState = {
        contactname: "",
        contactemail: "",
        contactphone: "",
        services: "",
        contactmessage: ""
    };

    const [saveContactData, setSaveContactData] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");

    const handlechangedata = (e) => {
        const value = e.target.value;
        const key = e.target.name;
        
        setSaveContactData({ ...saveContactData, [key]: value });
        
        // Clear the specific error for this field as soon as the user starts typing
        if (errors[key]) {
            setErrors({ ...errors, [key]: false });
        }
    };

    const saveallcontactdetails = (e) => {
        e.preventDefault();

        let newErrors = {};
        let isValid = true;

        // Validation checks
        if (saveContactData.contactname.trim() === "") {
            newErrors.contactname = true;
            isValid = false;
        }
        if (saveContactData.contactemail.trim() === "") {
            newErrors.contactemail = true;
            isValid = false;
        }
        if (saveContactData.contactphone.trim() === "") {
            newErrors.contactphone = true;
            isValid = false;
        }
        if (saveContactData.services === "" || saveContactData.services === "0") {
            newErrors.services = true;
            isValid = false;
        }
        if (saveContactData.contactmessage.trim() === "") {
            newErrors.contactmessage = true;
            isValid = false;
        }

        setErrors(newErrors);

        if (!isValid) return;

        const dataString = {
            "contact_name": saveContactData.contactname,
            "contact_email": saveContactData.contactemail,
            "contact_mobile": saveContactData.contactphone,
            "contact_subject": saveContactData.services,
            "contact_message": saveContactData.contactmessage
        };

        apiServices.contactusleadsPostRequest(dataString).then(res => {
            if (res.data.status === "success") {
                setSuccessMessage(res.data.data);
                
                setTimeout(() => {
                    setSaveContactData(initialFormState);
                    setSuccessMessage("");
                }, 3000);
            }
        });
    };

    return (
        <>
            <div className="wrapper">
                <Header />
                <section className="google-map py-0">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3556.9114783983287!2d75.75078827527122!3d26.938020659002696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db30cb6fb48ef%3A0xb1d659bf8b92a253!2sCJL%20FinTech%20Solutions%20(Rocket%20Paisa)!5e0!3m2!1sen!2sin!4v1687784695041!5m2!1sen!2sin" 
                        frameBorder="0" 
                        height="620" 
                        width="100%" 
                        style={{ border: "0" }} 
                        allowFullScreen="" 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Rocket Paisa Location"
                    ></iframe>
                </section>
                
                <section className="contact-layout1 pt-0 mt--100">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="contact-panel d-flex flex-wrap shadow-sm bg-white">
                                    
                                    {/* FORM SECTION */}
                                    <div className="contact-panel__form flex-grow-1 p-5">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                {successMessage !== "" && (
                                                    <div className="alert alert-success" role="alert">
                                                        {successMessage}
                                                    </div>
                                                )}
                                                <h4 className="contact-panel__title fw-bold mb-2">Get in Touch</h4>
                                                <p className="contact-panel__desc mb-30 text-muted">
                                                    We're just a message away. Contact us for any queries or assistance regarding our services.
                                                </p>
                                            </div>
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        placeholder="Name" 
                                                        id="contactname" 
                                                        name="contactname"
                                                        value={saveContactData.contactname} 
                                                        onChange={handlechangedata}
                                                        style={{ border: errors.contactname ? "1px solid red" : "" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <input 
                                                        type="email" 
                                                        className="form-control" 
                                                        placeholder="Email" 
                                                        id="contactemail" 
                                                        name="contactemail"
                                                        value={saveContactData.contactemail}
                                                        onChange={handlechangedata}
                                                        style={{ border: errors.contactemail ? "1px solid red" : "" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        placeholder="Phone" 
                                                        id="contactphone" 
                                                        name="contactphone"
                                                        value={saveContactData.contactphone}
                                                        onChange={handlechangedata}
                                                        style={{ border: errors.contactphone ? "1px solid red" : "" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <select 
                                                        className="form-control" 
                                                        name="services" 
                                                        id="services"
                                                        value={saveContactData.services}
                                                        onChange={handlechangedata}
                                                        style={{ border: errors.services ? "1px solid red" : "" }}
                                                    >
                                                        <option value="0">Select Your services</option>
                                                        <option value="1">Aadhaar Enabled Payment System</option>
                                                        <option value="2">Bill Payments : BBPS</option>
                                                        <option value="3">MicroATM</option>
                                                        <option value="4">PAN Card Center</option>
                                                        <option value="5">Aadhaar Pay</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <textarea 
                                                        className="form-control" 
                                                        placeholder="Additional Details" 
                                                        id="contactmessage" 
                                                        name="contactmessage"
                                                        rows="4"
                                                        value={saveContactData.contactmessage}
                                                        onChange={handlechangedata}
                                                        style={{ border: errors.contactmessage ? "1px solid red" : "" }}
                                                    ></textarea>
                                                </div>
                                                <button 
                                                    type="button" 
                                                    onClick={saveallcontactdetails}
                                                    className="btn btn__secondary btn__block btn__xhight d-flex justify-content-between mt-10"
                                                >
                                                    <span>Submit Request</span> <i className="icon-arrow-right icon-outlined"></i>
                                                </button>
                                                <div className="contact-result"></div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* CONTACT INFO SIDEBAR */}
                                    <div className="contact-panel__info d-flex flex-column justify-content-between bg-overlay bg-overlay-primary-gradient p-5 text-white" style={{ minWidth: "350px", backgroundColor: "#0b2046" }}>
                                        <div>
                                            <h3 className="contact-panel__subtitle color-white mb-4 fw-bold">Contact Information</h3>
                                            
                                            <ul className="contact__list list-unstyled mb-0" style={{ fontSize: "15px", lineHeight: "1.6" }}>
                                                
                                                <li className="mb-4">
                                                    <strong className="d-block mb-1 text-uppercase" style={{ letterSpacing: "1px", fontSize: "12px", opacity: 0.8 }}>Corporate Office</strong>
                                                    A-1, Parivahan Nagar, Khatipura Road<br />
                                                    Jaipur-302012 (Raj.)
                                                </li>
                                                
                                                <li className="mb-4">
                                                    <strong className="d-block mb-1 text-uppercase" style={{ letterSpacing: "1px", fontSize: "12px", opacity: 0.8 }}>Registered Office</strong>
                                                    Dhani Hemawali, Raj Nagar<br />
                                                    Neem Ka Thana, Sikar 332713 (Raj.)
                                                </li>

                                                <li className="mb-4">
                                                    <strong className="d-block mb-1 text-uppercase" style={{ letterSpacing: "1px", fontSize: "12px", opacity: 0.8 }}>Support Contact</strong>
                                                    <a href="tel:+919358190092" className="text-white text-decoration-none fw-bold fs-5">+91-9358190092</a>
                                                </li>

                                                <li className="mb-4">
                                                    <strong className="d-block mb-1 text-uppercase" style={{ letterSpacing: "1px", fontSize: "12px", opacity: 0.8 }}>Email</strong>
                                                    <a href="mailto:support@rocketpaisa.in" className="text-white text-decoration-none">support@rocketpaisa.in</a>
                                                </li>

                                                <li>
                                                    <strong className="d-block mb-1 text-uppercase" style={{ letterSpacing: "1px", fontSize: "12px", opacity: 0.8 }}>Working Hours</strong>
                                                    Monday to Saturday: 10:00 AM - 6:00 PM<br />
                                                    <span className="text-warning fw-bold d-block mt-1">24*7 Support Available</span>
                                                    <span style={{ fontSize: "13px", opacity: 0.9 }}>Sunday: Closed (Emergency Support Only)</span>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                    {/* END CONTACT INFO SIDEBAR */}

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    );
}

export default Contact;